class ProductPrice extends HTMLElement {
  connectedCallback() {
    this.unsubscribeVariantChange = subscribe(
      `variant:changed:${this.dataset.productId}`,
      ({ html }) => {
        this.handlePriceChange(html);
      }
    );
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange();
  }

  /**
   * Handle price change.
   * @param {HTMLElement} html - The HTML to render.
   */
  handlePriceChange(html) {
    const productPrice = html.querySelector('product-price');
    this.innerHTML = productPrice.innerHTML;
  }
}

customElements.define('product-price', ProductPrice);
